let ques = [
  {
    类型: '雅思',
    题目: "The most important thing of people's life is his or her work. Without a satisfying career, the life is meaningless. To what extent do you agree or disagree?",
    备注: '2013年1月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Children spend long time studying in school and after school. What are the positive or negative effects on children and the society as a whole?',
    备注: '2013年1月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think watching TV every day is bad for children. Others think it is good for developing children as they grow up. Discuss both these views and give your own opinion.',
    备注: '2013年2月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe young people should be free to choose his or her job, but others think they should be realistic and think about their future. Discuss and give your opinion.',
    备注: '2013年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think all lawbreakers should be put into prison, others believe that there are better alternatives. Discuss and give your opinion.',
    备注: '2013年2月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Not enough students choose science subjects in university in many countries. What are the reasons? What are the effects on the society?',
    备注: '2013年2月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more people tend to accept education through the internet, and therefore, face-to-face communication is decreasing. Do you think the advantages outweigh the disadvantages?',
    备注: '2013年3月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe that studying in a college or university is the best way for students to prepare for their future career. Others think they should leave school as soon as possible to develop their career through work experience. Discuss both these views and give your own opinion.',
    备注: '2013年3月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'It is more important for a building to focus on its function. Architects should not worry about its looks. Do you agree or disagree?',
    备注: '2013年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Scientific progress has greatly influenced our daily life. Do you think this is a positive or negative development?',
    备注: '2013年3月23日全真题',
  },
  {
    类型: '雅思',
    题目: "100 years ago, the human race believed we would make continued progress in all areas of life. Today, some people feel less certain about this. In what areas has the human race made progress? In what other areas haven't we developed?",
    备注: '2013年4月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'As countries develop, their populations tend to live individually or in a small family unit. What are the reasons? What are the effects on society and family life?',
    备注: '2013年4月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'For older school children, some people think that these children should study a large number of subjects, but others believe that children should study less subjects but in details. Discuss both these views and give your own opinion.',
    备注: '2013年4月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'The quality of life in big cities is decreasing. What are the causes and what actions should be taken to solve this problem?',
    备注: '2013年5月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'Advertising can influence the way people think, so it has negative effects. Do you agree or disagree?',
    备注: '2013年5月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think learning history in school is important. Others think learning subjects more relevant to life is important. Discuss both these views and give your own opinion.',
    备注: '2013年5月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that the money government spend on art, such as music and painting, would be better spent on things more important. Do you agree or disagree?',
    备注: '2013年5月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think government should be responsible for providing financial support to old people after they retire, but others believe individuals should save money for themselves. Discuss both these views and give your own opinion.',
    备注: '2013年6月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays some countries encourage people to buy more and more products, which is good for economy, while others believe it is bad for the society. Discuss both these views and give your own opinion.',
    备注: '2013年6月8日全真题',
  },
  {
    类型: '雅思',
    题目: "Some people think family has great influence on children's development. Others, however, believe that other things, such as media, have greater effects. Discuss both these views and give your own opinion.",
    备注: '2013年6月15日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think secondary school should have a class of international news. Others believe it is not necessary. Discuss both views and give your opinion.',
    备注: '2013年6月22日全真题',
  },
  {
    类型: '雅思',
    题目: "Some people think space tourism can help to develop countries' economy. What's your opinion? What are the effects?",
    备注: '2013年7月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'The tendency for human beings to copy one another is shown in the popularity of fashion in clothes and other consumer goods. Do you agree or disagree?',
    备注: '2013年7月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'In modern society, it is possible to go shopping, work and communicate via the Internet without face-to-face contact with one another. To what extent do you think this is a positive or negative development?',
    备注: '2013年7月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'The restoration of old buildings in major cities in the world spends numerous government expenditures. This money should be used in new housing and road development. To what extent do you agree or disagree?',
    备注: '2013年7月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries today, people in cities either live alone or in small family units, rather than in large, extended family groups. Is this a positive or negative trend?',
    备注: '2013年8月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'in some countries， students pay their college or university fees, while in some others, government pays for them. Do you think the advantages that government pays the money outweigh the disadvantages?',
    备注: '2013年8月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that in modern society individuals are becoming more dependent on each other. But others say that individuals are becoming more independent on each other. Discuss both views and give your own opinion.',
    备注: '2013年8月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some scientists think it is very soon that computers will be more intelligent than human. Some people think it is a positive development, while others think it is a negative development. Discuss both views and give your opinion.',
    备注: '2013年8月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nuclear energy is the best source of power in meeting ever-increasing energy needs. To what extent do you agree or disagree?',
    备注: '2013年9月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Countries with a long average working time are more economically successful than those countries which do not have a long working time. To what extent do you agree or disagree?',
    备注: '2013年9月12日全真题',
  },
  {
    类型: '雅思',
    题目: "Throughout the history, people dream to build a perfect society while they haven't agreed how the ideal society would be like. What is the most important element you think to make a perfect society? How do people do to achieve an ideal society?",
    备注: '2013年9月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think they have right to use as much fresh water as they want. Others otherwise believe governments should strictly control the use of fresh water as it is a limited resource. Discuss both views and give your own opinion.',
    备注: '2013年9月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think giving aid to poorer countries has more negative effects than positive ones. To what extent do you agree or disagree?',
    备注: '2013年10月10日全真题',
  },
  {
    类型: '雅思',
    题目: "Economic progress is one way to measure a country's success. Other people think other factors are also important. What are the other factors? Which factor is the most important one?",
    备注: '2013年10月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many parents these days work in other countries, taking their families with them. Do you think the advantages of the development outweigh its disadvantages?',
    备注: '2013年10月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think a rise in standard of living in a country only seems to benefit cities more than rural areas. What problems may those differences cause? How to reduce this problem?',
    备注: '2013年10月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Young people who commit serious crimes should be punished in the same way as adults. To what extent do you agree or disagree?',
    备注: '2013年11月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'In the world, only a few languages are increasing in use，while many others are declining. Do you think this is a positive or negative development?',
    备注: '2013年11月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'As part of education, students should spend a period of time studying and living in a different country to learn language and culture. To what extent do you agree or disagree?',
    备注: '2013年11月21日全真题',
  },
  {
    类型: '雅思',
    题目: "People are buying more and more products from famous brands such as clothes, cars, and other items. What are the reasons for this? Do you think it's a positive or a negative development?",
    备注: '2013年11月30日全真题',
  },
  {
    类型: '雅思',
    题目: 'In recent years, ‘responsible tourists’ have paid attention to preserving both culture and environment of the places they visit. However, some people say that it is impossible to be a responsible tourist. Do you agree or disagree?',
    备注: '2013年12月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, more and more people buy a wide range of household goods like television, microwave oven and rice cooker. Do you think this is a positive or negative development?',
    备注: '2013年12月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Young people are leaving their homes from rural areas to study or work in the cities. What are the reasons? Do the advantages of this development outweigh its disadvantages?',
    备注: '2013年12月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Scientists advise people to lead a healthy lifestyle, but most people continue with unhealthy activities. Why? Solutions.',
    备注: '2013年12月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'The leaders or directors of organizations are often older people. But some people say that young people can also be a leader. To what extent do you agree or disagree?',
    备注: '2015年1月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthattheamountofnoisepeoplemakeshouldbecontrolledstrictly,whileothersaythatpeoplearefreetomakeasmuchnoiseastheywish.Discussbothviewsandgiveyouropinion.',
    备注: '2015年1月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Itispossibleforscientistsandtouriststotraveltoremotenaturalenvironments,suchasSouthPole.Doyouthinktheadvantagesofthisdevelopmentoutweighthedisadvantages?',
    备注: '2015年1月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplearguethattoomuchattentionandtoomanyresourcesaregiventotheprotectionofwildanimalsandbirds.Towhatextentdoyouagreeordisagree?',
    备注: '2015年1月31日全真题',
  },
  {
    类型: '雅思',
    题目: 'Manymuseumsandhistoricalsitesaremainlyvisitedbytourists,notlocalpeople.Why?Whatcanbedonetoattractlocalpeople?',
    备注: '2015年2月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthattheagelimitfordrivingshouldbeincreasedinordertomakedrivingsafer.Towhatextentdoyouagreeordisagree?',
    备注: '2015年2月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Theuseofmobilephoneisasantisocialassmoking.Smokingisbannedincertainplacessomobileshouldbebannedlikesmoking.Towhatextenddoagreeordisagree?',
    备注: '2015年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somestudentstakeoneyearoffbetweenfinishingschoolandgoingtouniversity,inordertotravelortowork.Doyouthinkadvantagesoutweighdisadvantages?',
    备注: '2015年2月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatitismoreimportanttoplantmoretreesinopenareaintownsandcitiesthanbuildmorehousing.Towhatextenddoagreeordisagree?',
    备注: '2015年3月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Someworkingparentsthinkchildcarecentercanprovidetheirchildrenbestcare.Whileothersthinkfamilymemberssuchasgrandmawillexperiencecangivechildrenbestcare.Towhatextentdoyouagreeordisagree?',
    备注: '2015年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplebelievefamouspeople’ssupporttowardsinternationalaidorganizationsdrawstheattentiontoproblems,whileothersthinkcelebritiesmaketheproblemslessimportant.Discussbothviewsandgiveyouropinions.',
    备注: '2015年3月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthattheincreasinguseofcomputersandmobilephonesforcommunicationhashadanegativeeffectonyoungpeople’sreadingandwritingskills.Doestheadvantageoutweighthedisadvantage?',
    备注: '2015年3月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Olderpeoplewhoneedemploymenthavetocompetewithyoungerpeople.Whatproblemswillbecaused?Andwhatarethesolutions?',
    备注: '2015年4月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplebelievethatonlystudentswithbestacademicshouldbereward,someotherpeoplethinkitismoreimportanttorewardstudentswithimprovement.Discuss&Giveyouropinion.',
    备注: '2015年4月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Youngpeoplewhocommitseriouscrimes,suchasarubberyoraviolentattackshouldbepunishedinthesamewayasadults.Towhatextentdoyouagreeordisagree?',
    备注: '2015年4月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'AnAmericanwriterthinkthattomorrowismoreimportant.Towhatextentdoyouagreeordisagree?',
    备注: '2015年4月30日全真题',
  },
  {
    类型: '雅思',
    题目: 'Governmentsshouldfocusspendingonlyonpublicservices,notwasteonthearts.Towhatextentdoyouagreeordisagree?',
    备注: '2015年5月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Healthexpertsclaimthatwalkingisthebestexercise.However,peoplearewalkinglessonadailybasis.Whathasmadeithappenandhowtodealwiththis?',
    备注: '2015年5月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Peoplecontinuetocommitcrimesevenafterbeingpunishedforit.Whydoyouthinkthishappens?Howcancrimebestopped?',
    备注: '2015年5月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'SomepeoplethinkcomputersandtheInternetaremoreimportantinchild’seducation.Othersbelievethatschoolsandteachersareessentialforchildrentolearn.Discussbothviewsandgiveyouropinion.',
    备注: '2015年5月30日全真题',
  },
  {
    类型: '雅思',
    题目: 'Moreandmorepeoplewanttostudyatuniversity,socompetitionofuniversityplacesisincreasing.Whydomorepeoplewanttostudyatuniversity?Isitpositiveornegative?',
    备注: '2015年6月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'Universitystudentsshouldpayforthefullcostofeducationfeesbecauseuniversityeducationbenefitsthemselvesratherthanthesociety.Towhatextentdoyouagreeordisagree?',
    备注: '2015年6月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Weshouldreturntotraditionalandoldervaluesofrespectforfamilyandcommunity.Towhatextentdoyouagreeordisagree?',
    备注: '2015年6月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkitisimportanttoprotectallwildanimals.Othersthinkthatitisonlyimportanttoprotectpartofthem,notallofthem.Discussbothviewsandgiveyouropinion.',
    备注: '2015年6月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'Oldpeoplehavetheirownideasofhowtothink,behaveandlive,anditisnotsuitableforyoungpeopleinpreparingtheirmodernlife,discussbothviewsandgiveyouropinion.',
    备注: '2015年7月4日全真题',
  },
  {
    类型: '雅思',
    题目: 'Inmodernlifeitisunnecessarytoteachchildrentheskillofhandwriting,doyouagreeordisagree?',
    备注: '2015年7月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplesaythatwhendividinghowtaxesshouldbespent,thegovernmentshouldprioritizehealthcare.Towhatextentdoyouagreeordisagree?',
    备注: '2015年7月23日全真题',
  },
  {
    类型: '雅思',
    题目: '　Somepeoplethinkthatsporthasanimportantroleinsociety.Othersthinkitisonlyaleisureactivityforsomepeople.Discussbothviewsandgiveyouropinions.',
    备注: '2015年7月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Theproportionofelderlypeopleinsomesocietiesisincreasingrapidly.Doyouthinkthenegativeeffectofsuchtrendoutweighthepositiveeffect?',
    备注: '2015年8月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadayspeopletendtotravellongdistancetoworkeveryday.Whatarethereasonsandsuggestions?',
    备注: '2015年8月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Internationaltravelmakepeopleprejudicedmorethanboard-mind,why?Howtoimprovetheunderstandingofcountriestheyvisit?',
    备注: '2015年8月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplebelievethatuniversityeducationshouldfocusontheskillsofemploymentforthefuture.Othersthinkshouldfocusacademicstudyonly.Discussbothviewsandgiveyouropinion.',
    备注: '2015年8月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Peopleareafraidtoleavetheirhomesforfearofcrimes.Somepeoplebelievethatmoreactionshouldbetakentopreventcrimeswhileothersthinkthatlittlecouldbedone.Discussbothsidesandgiveyouropinion.',
    备注: '2015年9月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'Insomecountriesoldpeoplearehighlyvalued,whileinsomeculturesyoungpeoplearehighlyvalued.Discussbothviewsandgiveyouropinion.',
    备注: '2015年9月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Educationaliststhinkthattheprogramofinternationalexchangevisitswouldbenefitallstudents.Towhatextentdoyouagreeordisagree?',
    备注: '2015年9月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeopleclaimthatmanythingsthatchildrenaretaughtatschoolareawasteoftime.Otherpeoplearguethateverythingstudyatschoolareusefulatsometime.Discussbothviewsandgiveyourownopinion.',
    备注: '2015年9月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Insomecountries,secondaryschoolsaimtoprovideageneraleducationacrossarangeofsubjects.Inothers,childrenfocusonanarrowrangeofsubjectsrelatedtoaparticularcareer.whichisappropriateintoday’sworld.',
    备注: '2015年10月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Thesedays，thereisnoneedstogooutforaliveperformance(show，concert)，becausewatchingitathomeonTVorcomputerscreenisbetter.Towhatextentdoyouagreeordisagree?',
    备注: '2015年10月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Shouldpeopleusemobilephonesinpublicplaces?',
    备注: '2015年10月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplesaythateveryonecancreateart,butothersthinkonlythosewhoaretalentedorhavespecialskillscancreateart.Discussbothviewsandgiveyourownopinion.',
    备注: '2015年10月31日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatthenewsmediahavemuchmoreinfluentialinpeople’slivesandthatthisisanegativedevelopment.Towhatextentdoyouagreeordisagree?',
    备注: '2015年11月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Economicgrowthininrecentyearsmadesomepeopleinbothdevelopedcountriesanddevelopingcountriesricher.However,researchshowingthatwhilepeopleindevelopingcountriesarehappier,peopleindevelopedcountriesseemsnohappierthanbefore.Why?Whatcanwelearnfromit?',
    备注: '2015年11月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Machineshavereplacedphysicalworkinmanyindustries.Doyouthinktheadvantagesoutweighthedisadvantages?',
    备注: '2015年11月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplebelievethatparentsshouldtakepunishmentsforthecrimeoftheirchildren.Towhatextentdoyouagreeordisagree?',
    备注: '2015年11月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Interviewisthebasicformofselectingprocedureformostlargecompanies.Somepeoplethinkitisunreliableandtherearesomeotherbettermethods.Discussandgiveyourownopinion.',
    备注: '2015年12月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'Thereisanincreasingamountofanti-socialbehaviorandlackofrespectforothers.Whatarethecausesofthisproblemandwhatareyoursolutions?',
    备注: '2015年12月5日全真题',
  },
  {
    类型: '雅思',
    题目: 'Readingstorybooksisbetterforchildrenthanwatchingtelevisionorplayingcomputergames.Towhatextentdoyouagreeordisagree?',
    备注: '2015年12月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatculturaltraditionswillbedestroyedastheyareusedasmoney-makingattractions,whileothersthinkitistheonlywaysosavethem.Discussbothviewsandgiveyouropinion.',
    备注: '2015年12月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthebestwaytosolvetrafficcongestionsincitiesistoprovidefreepublictransport24hoursaday,7daysaweek.Towhatextentdoyouagreeordisagree?',
    备注: '2014年1月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadaysmanyyoungpeopleinworkforcechangetheirjobsorcareerseveryfewyears.Whatdoyouthinkarethereasonsforthis?Dotheadvantagesoutweighdisadvantages?',
    备注: '2014年1月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'Manychildrenfinditisdifficulttoconcentrateorpayattentionatschool.Whatarethecauses?Thepossiblesolutionstothisproblems?',
    备注: '2014年1月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Theinternationalcommunityshouldimmediatelyreducetheconsumptionoffossilfuelsofallcountries.Towhatextentdoyouagreeordisagree?',
    备注: '2014年1月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplebelievethebestwaytoproduceabettersocietyistoensurethereisonlyasmalldifferencebetweentheearningsoftherichestandthepoorest.Towhatextenddoyouagreeordisagree?',
    备注: '2014年2月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Manypeoplethinkthepaintingandmusicdonotdirectlyimprovethequalityofpeople,thereforethegovernmentshouldnotspendthemoneyinarts,andtheyshouldspendmoremoneyonconstructionofpublicfacilities.Towhatextentdoyouagreeordisagree?',
    备注: '2014年2月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinksuccessoflifeisbasedonhardworkanddeterminationbutothersthinktherearemoreimportantfactorslikemoneyandappearance.Discussbothsidesandgiveyourownopinion?',
    备注: '2014年2月15日全真题',
  },
  {
    类型: '雅思',
    题目: 'Children’seducationisexpensive.Insomecountries,thegovernmentpaysomeoforallofthecosts.Dotheadvantagesoutweighitsdisadvantages?',
    备注: '2014年2月22日全真题',
  },
  {
    类型: '雅思',
    题目: "Somepeoplethinklivinginbigcitiesisbadforpeople'shealth.Towhatextentdoyouagreeordisagree?",
    备注: '2014年3月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkyoungpeoopleshouldberequiredtohavefulltimeeducationuntiltheyareatleast18yearsold.Towhatextentdoyouagreeordisagree?',
    备注: '2014年3月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Manypeoplebelievethatprintedbooksarenotgoodinthisdigitalera,becausecomputercanstoremoreinformation,whileothersthinksprintedbooksarestillplayingasignificantrole.Discussbothviewsandgiveyourownideas.',
    备注: '2014年3月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Itisimportantforalltownsandcitiestohavelargepublicoutdoorplaceslikesquaresandparks.Towhatextentdoyouagreeordisagree?',
    备注: '2014年3月15日全真题',
  },
  {
    类型: '雅思',
    题目: 'Anincreasingnumberofpeoplechangetheircareerandplacesofresidenceseveraltimesduringtheirlife.Isthisapositiveornegativedevelopment?',
    备注: '2014年4月5日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somesaythepurposeofeducationistoprepareindividualstobeusefultosociety.Othessaythepurposeofeducationistoachievepersonalambitions.Discussbothviewsandgiveurownopinion.',
    备注: '2014年4月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Televisionadvertisementaimedatchildren.Whateffectsofthisonchildren?ShouldTVadvertisementbecontrolled?',
    备注: '2014年4月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Computertechnologiesaremoreaccessibleandcheaper,astheresult,moreadultsworkathomeandchildrenstudyathome.Isthisapositiveornegativedevelopment?',
    备注: '2014年4月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays,womenhavefuu-timeworksameasmen,logicallymenshouldsharehouseholdequallywithwomen.Towhatextentdoyouagreeordisagree?',
    备注: '2014年5月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Employersshouldgivetheirstaffatleasta4-weekholidayayeartomakeemployeesbetterattheirjobs.Towhatextenddoyouagreeordisagree?',
    备注: '2014年5月15日全真题',
  },
  {
    类型: '雅思',
    题目: 'Childrencanlearneffectivelyfromwatchingtelevision.Thereforechildrenshouldbeencouragedtowatchtelevisionregularlybothathomeandatschool.Towhatextentdoyouagreeordisagree?',
    备注: '2014年5月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Manyyoungpeopleleaveschoolwithanegativeattitude.Whatarethereasons?Howcanweencourageyoungpeopletostudy?',
    备注: '2014年5月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatifapoliceforcecarriesagun,itcanleadtohigherlevelofcrimeinthatsociety.Towhatextentdoyouagreeordisagree?',
    备注: '2014年6月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkadultsshouldlearnpracticalskillsbythemselves,whileothersbelievethatlearningfromateacherinaclassroomisbetter.Discussbothviewsandgiveyourownopinion.',
    备注: '2014年6月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Anincreasingnumberofpeoplearechangingtheircareers.Whatarethereasons?Doyouthinkitispositiveornegative?',
    备注: '2014年6月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Withtheincreasingdemandforenergysourcesofoilandgas,peopleshouldlookforsourcesofoilandgasinremoteanduntouchednatruralplaces.Dotheadvantagesoutweighdisadvantagesofdamagingsuchareas?',
    备注: '2014年6月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somecountriesachieveinternationalsuccess,buildingspecializedsportsfacilitiesfortopathletestotraininsteadofprovidingsportsfacilitiesthateveryonecanuse.Positiveornegative?',
    备注: '2014年7月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkyoungerpeoplearenotsuitableforimportantpositionsingovernmentincountries.Somethinkitwillbeagoodideaforyoungerpeopletotakeonthesepositions.Agreeordisagree?',
    备注: '2014年7月12日全真题',
  },
  {
    类型: '雅思',
    题目: "Somepeoplebelievethatthegovernmenthavethedutytoensureitscitizenshaveahealthydiet,whileothersbelieveitisindividuals'responsibilitytocarefortheirdietandhealth?Discussbothsidesandgiveyouropinion?",
    备注: '2014年7月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatenvironmentalproblemsaretoobigforindividualstosolve.Others,however,believethattheproblemscannotbesolvedifindividualsdonottakeactions.Discussbothviewsandgiveyourownopinion.',
    备注: '2014年7月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Childrenarecommittingmorecrimes.Whatarethecauses?Howtopunishthem?',
    备注: '2014年8月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkthatdangeroussportsshouldbebanned,butothersthinkthepeopleshouldhavefreedomtochoosesportsactivities.Discussbothviewsandgiveyouropinion.',
    备注: '2014年8月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Governmentsareencouragingindustriesandbusinessestomovefromlargecitiestoregionalareas.Dotheadvantagesoutweighthedisadvantages?',
    备注: '2014年8月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Towhatextentdoyouthinksocietiesbenefitfromthecontactandcloserrelationshipwithforeignersbroughtaboutbyinternationalbusinessandtourism?',
    备注: '2014年8月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Withmajorcitiescontinuegrowing,arethereanyproblemstoyoungpeople?Howtosolvetheseproblems?',
    备注: '2014年9月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'Indevelopingcountries,somepeoplethinkthegovernmentshouldintroducenewtechnologytopeopleinordertoimprovequalityoflife,whileothersbelievegovernmentsshouldofferfreeeducation.Discussbothsidesandgiveyourownopinion.',
    备注: '2014年9月20日全真题',
  },
  {
    类型: '雅思',
    题目: 'Recentlyyears,moreandmorepeoplechoosetolivebythemselves,why?Isitpositiveornegativeforthedevelopmentofthesociety?',
    备注: '2014年9月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'Itisnotnecessarytotraveltootherpalcestolearnabouttheotherculture.wecanlearnasmuchasfrombooks,filmsandinternet.Towhatextentfoyouagreeordisagree?',
    备注: '2014年10月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplesayjobsatisfactionismoreimportantthanjobsecurity,otherthinkpeoplecannotalwaysexpectenjoyinjobs,workingpermanentlyismoreimportant.Discussbothandurview.',
    备注: '2014年10月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Itisbetterforpeopletobeunemployedthanpeopletobeemployedbuttheydonotenjoy.Doyouagreeordisagree?',
    备注: '2014年11月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somethinkmostcrimeistheresultofcircumstancese.g.povertyandothersocialproblems.Othersbelievethatmostcrimeiscausedbypeoplewhoarebadbynature.Discussbothsidesandgiveyourownopinion.',
    备注: '2014年11月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Researchersshowthatovereatingisasharmfulassmoking.Therefore,advertisingforfoodproductsshouldbebannedinthesamewayasthecigarette,advertisingisbannedinmanycountries.Towhatextentdoyouagreeordisagree?',
    备注: '2014年11月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Onlineshoppingisnowreplacingshoppinginstore.Doyouthinkitispositiveornegativedevelopment?',
    备注: '2014年11月22日全真题',
  },
  {
    类型: '雅思',
    题目: "Somepeoplethinklanguageclassshouldbetaughtinsmallclass,othersthinkthenumberofstudentsdoesn'tmatter.Doyouagreeordisagree?",
    备注: '2014年12月4日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somethink“VerticalCity”isthebestwherepeopleliveandworkintallbuildings.Othersthink“HorizontalCity”isbetterwherethereisfewtallbuildings.Discussbothviewsandgiveyourownopinion.',
    备注: '2014年12月6日全真题',
  },
  {
    类型: '雅思',
    题目: "Shopsshouldnotbeallowedtosellanyfoodanddrinkswhichareprovedtobescientificallyharmfulforpeople'shealth.Doyouagreeordisagree?",
    备注: '2014年12月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Somepeoplethinkpaintinganddrawingsareasimportantasothersubjects,theyshouldbecompulsoryinhighschooleducation.Whatdoyouthink?',
    备注: '2014年12月20日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that any money spent by the government in supporting artist (such as painters, musicians and writers) should be spent on more important things. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Students in university should be specialized in one subject rather than to develop a wider range of many different subjects. To what extent do you agree or disagree with this statement?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some groups of people benefited from the modern communications technology but some people have not benefited at all. Do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In recent years pressure on school and university students has been increasing and they are pushed to work very hard from a young age. Do you think this is a positive or negative development?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Full-time university students should spend a lot of time in studying, but it is essential to be involved in other activities. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In many parts of the world children now are given more freedom than they used to have. Do you think it is a positive or negative development?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think parents should read or tell stories to children. Others think parents need not do that as children can read books or watch TV, movies by themselves. Discuss both views and give your own',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'More attention is paid to being “responsible tourists” in order to preserve the cultural and environmental aspects of tourist places. However, some people think it is impossible to be a “responsible t',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In some cities, planners tend to arrange shops, schools, offices and homes in specific areas and separate them form each other. Do you think the advantages outweigh the disadvantages?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Living in big cities is bad for people’s health. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some think that practical subjects are more important than theoretical subjects in university, and the latter will be replaced by the former in the future. To what extend do you agree or disagree with this idea?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe that the country development benefits from the high-educated university students. However some people think that the large amount of young people in university only leads to high unemploymentg raduates.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Government funding should only provide scholarships for best students. All other funding should come from student fees and private organizations. Agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some young people commit serious crimes, such as robbery or violent attacks, some people think they should be punished in the same way as adults. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries, it is possible to buy a wide variety of foods transported from other countries. To what extent the benefits outweigh its drawbacks.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'The government should control the amount of violence in films and on television in order to decrease the level of violent crime in society. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Give detailed description of crimes in newspaper and on television can have bad consequences. So information of this kind in the media should be restricted. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, people decide to have children at a later age than in the past? Why? Do advantages of this development outweigh disadvantages?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Children today find it difficult to concentrate or pay attention in schools. Why do you think causes this problem? What do you need to do to solve this problem?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Most young people leave school with a negative attitude toward learning. Why do you think this is happening? What can be done to encourage them to have a positive attitude?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Children can learn effectively through watching TV. Therefore, children should be encouraged to watch TV regularly both at home and at school. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some said teachers’ main role is to transmit the information. Nowadays students are exposed to many kinds of information, so the role of the teacher will not work in modern education. Do you agree or disagree with this opinion?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In the past, people store knowledge in the books. Nowadays people store knowledge on the internet. Do you think the advantages outweigh the disadvantages?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In modern society, ambition is more and more important. How important is ambition for being successful in life? Is it positive or negative?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think it is best to live in the vertical city where there are a lot of tall building, other people think we should live in the horizontal city where they are few tall building.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think the technology makes life complex, so we should make our life simpler without using the technology. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people want government to spend money on life on other planets, however, others think it is a waste of public money when the earth has so many problems. Discuss these two views and give your own opinion.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Art classes, like painting and drawing are as important as other subject, should be compulsory subject in high school. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some cities have vehicle -free days, when private cars, trucks, motorcycles are banned in the city center. Public transportation like buses, taxis and metros are advised. To what extent do you think the advantages outweigh the disadvantages?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Somebody thinks job satisfaction is more important than job security, while others hold the opposite view: job permanent is much more important. Discuss both views and give your own opinion.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Many people suggest that the best way to solve traffic congestion is to free public transport. To what extent do you agree or disagree?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'An increasing number of people change their career and place of residence several times during their lives. It is positive or negative development?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries the widespread use of internet has given people more freedom to work or study at home instead of travelling to work or college. Do the advantages outweigh disadvantages?',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe the purpose of education is to prepare people to be useful members for society. Others say that the purpose of education is to achieve personal ambitions. Discuss both views and give your owno pinion.',
    备注: '2017年全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people argue that the fittest and strongest individuals and teams always achieve the greatest success in sports. But other people think the success is more related to the mental attitude. Discuss both views and give your own opinions.',
    备注: '2019年1月5日全真题',
  },
  {
    类型: '雅思',
    题目: 'In modern society, it is no longer necessary to slaughter animals for producing food, or non-food products such as clothes or medicine. To what extent do you agree or disagree?',
    备注: '2019年1月5日全真题',
  },
  {
    类型: '雅思',
    题目: 'When new towns are planned, it is important to build more public parks or sports facilities than shopping centers, so people can places to spend their free time. To what extent do you agree or disagree?',
    备注: '2019年1月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'The environmental problems in the world cannot be solved by ordinary people because they can do little to change the situation. It is the responsibility of politicians. To what extent do you agree or disagree?',
    备注: '2019年1月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries, people waste a lot of food which is bought in shops and restaurants. What do you think are the reasons? What can be done to solve this problem?',
    备注: '2019年1月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think the best way to improve road safety is to increase the minimum legal age for driving cars and motorcycles. To what extent do you agree or disagree?',
    备注: '2019年1月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more people read news on the Internet, but newspapers will remain to be used by the majority of people. To what extent do you agree or disagree?',
    备注: '2019年1月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people argue that the best way to have a successful life is to attend college, but other people do not think so. Discuss both views and give your own opinion.',
    备注: '2019年1月19日全真题',
  },
  {
    类型: '雅思',
    题目: ' Some people believe that women should play an equal role as men in a country’s police force or military force, while others think women are not suitable for these jobs. Discuss both views and give your opinion.',
    备注: '2019年1月26日全真题',
  },
  {
    类型: '雅思',
    题目: ' More and more people want to buy clothes, cars and other items with famous brands. What are the reasons? Do you think it is a positive or negative development?',
    备注: '2019年2月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people say that organisations are more successful when managers and workers communicate well with each other. Other people say that there are more important factors that make organisations successful. Discuss both views and give your opinion.',
    备注: '2019年2月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'G类卷：Some people think that schools have not yet done enough to teach young people how to look after their health. To what extent do you agree or disagree?',
    备注: '2019年2月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'New technologies have changed the way children spend their free time. Do you think the advantages outweigh the disadvantages?',
    备注: '2019年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people claim that public museums and art galleries will not be needed because people can see historical objects and works of arts by using a computer. Do you agree or disagree with the following statement?',
    备注: '2019年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: "Nowadays, children spend too much time watching TV and playing computer games. Some people believe this has negative effects on children's mental abilities. To what extent do you agree or disagree？",
    备注: '2019年2月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that a huge amount of time and money is spent on the protection of wild animals, and that this money could be better spent on the human population. To what extent do you agree or disagree with this opinion?',
    备注: '2019年2月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that a huge amount of time and money is spent on the protection of wild animals and that money is better spent on human population. To what extent do you agree or disagree with this statement.',
    备注: '2019年2月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'Employers should give their staff at least 4-week holiday a year to make employees better at their job. To what extent do you agree or disagree?',
    备注: '2019年3月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'The world of work is changing rapidly and people cannot depend on the same job or same conditions of work for life. Discuss the possible causes for these changes and give your suggestions on how people should prepare for work in the future？',
    备注: '2019年3月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'As part of education, students should spend a period of time living in another country to study its language and culture. To what extent do you agree or disagree',
    备注: '2019年3月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe that the only purpose of films is to entertain; others say that films also have educational value. Please discuss both view and give your opinion.',
    备注: '2019年3月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Newspapers have an enormous influence on people‘s view. Why is that？Do you think it is a positive or negative development?',
    备注: '2019年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think the best way of reducing crime is to give longer prison sentences. Others, however, think there are other better ways to reduce crime. Discuss both views and give your own opinion.',
    备注: '2019年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Once children start school, teachers have more influence on intellectual and social development than parents. To what extent do you agree or disagree ?',
    备注: '2019年3月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'It is expected that there will be a higher proportion of older people than young people in many countries in the future. Do you think it is a positive or negative development?',
    备注: '2019年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that the best way to reduce time spend traveling to work is replace parks and gardens close to the city center with apartment buildings for commuters, but others disagree. Discuss both views and give your own opinion.',
    备注: '2019年4月6日全真题',
  },
  {
    类型: '雅思',
    题目: "Some people believe famous people's support towards international aid organizations draws the attention to problems, while others think celebrities make the problems less important. Discuss both views and give your opinion.",
    备注: '2019年4月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, people like to eat a wider variety of food than can be grown in their local area. As a result, much of the food people eat today has to come from other regions. Do you think the advantages of this development outweigh the isadvantages?',
    备注: '2019年4月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Young people living in rural areas have to study or work in big cities away from their homes. What are the reasons? Do the advantages outweigh the disadvantages?',
    备注: '2019年4月25日全真题',
  },
  {
    类型: '雅思',
    题目: "The increase use of technology in workplace. Some people find that it is good for young people's protects of gaining job and more harder for old people. To what extent do you agree or disagree?",
    备注: '2019年5月4日全真题',
  },
  {
    类型: '雅思',
    题目: 'Today many children spend a lot of time playing computer games and little time on sports. Why is it? Is it a positive or negative development.',
    备注: '2019年5月4日全真题',
  },
  {
    类型: '雅思',
    题目: 'Most of world’s problems are caused by over-population. To what extent do you agree or disagree?',
    备注: '2019年5月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many businesses think that the new employees who graduate from schools lack basic interpersonal skills, such as working with colleagues as a team. What has caused this and what are solutions to the problems?',
    备注: '2019年5月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'People nowadays are surrounded by all kinds of advertising. Advertising affects what people think is important and sometimes has a negative influence on people’s lives. To what extent do you agree or disagree?',
    备注: '2019年5月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Employees should give their staff at least 4-week holiday a year to make employees better at their jobs. To what extent do you agree or disagree?',
    备注: '2019年5月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, a high proportion of criminal acts are committed by teenagers. Why has this happened? What can be done to deal with this?',
    备注: '2019年5月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'There is little control over the design and construction of new homes and office buildings, and people can build in whatever style they like. Do the advantages outweigh the disadvantages?',
    备注: '2019年5月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'Human activities have negative effects on plant and animal species. Some people think it is too late to do anything about this problem. Others believe that effective measures can be taken to improve this situation. Discuss both views and state your own opinion.',
    备注: '2019年6月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'An increasing number of developing countries are expanding their tourist industry. Why do you think it is the case? Do you think it is a positive development?',
    备注: '2019年6月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Individuals can do nothing to improve the environment. Only governments and large companies can make a difference. To what extent do you agree or disagree with this opinion?',
    备注: '2019年6月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries today, people in cities either live alone or in small family units, rather than in large, extended family groups. Is this a positive or negative trend?',
    备注: '2019年6月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'As countries develop, more and more people buy and use their own cars. Do advantages of this trend for individuals outweigh the disadvantages for the environment?',
    备注: '2019年6月22日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many museums and historic sites are mainly visited by tourists, not local people. Why is it the case? What can be done to attract local people?',
    备注: '2019年6月22日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people claim that many things children learn at school have actually wasted their time. Other people argue that everything taught at school is useful in the future. Discuss both views and give your own opinion.',
    备注: '2019年6月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Sending criminals to prison is not the best method of dealing with them. Education and job training are better ways to help them. Do you agree or disagree?',
    备注: '2019年6月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more business meetings and business training have taken place on the Internet. Do the advantages of this development outweigh the disadvantages?',
    备注: '2019年7月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many people today prefer to eat locally produced food. Do the advantages of this trend outweigh disadvantages for the environment and economy.',
    备注: '2019年7月6日全真题',
  },
  {
    类型: '雅思',
    题目: 'The restoration of old buildings in major cities in the world costs enormous government expenditure. This money should be used in new housing and road development. To what extent do you agree or disagree?',
    备注: '2019年7月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Reading for pleasure can develop imagination and language skills better than watching TV. To what extent do you agree or disagree?',
    备注: '2019年7月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many people aim to achieve a balance between work and other parts of lives，but few people achieve it. What are the problems in trying to achieve it and how to overcome these problems？',
    备注: '2019年7月20日全真题',
  },
  {
    类型: '雅思',
    题目: 'The news media’s tendency to report problems and emergencies rather than positive development is harmful to individuals and the society. To what extent do you agree or disagree?',
    备注: '2019年7月20日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some parents give their children everything that their children ask for and accept what their children want to do. Is this good for children? What could be consequences for these children when they grow up?',
    备注: '2019年7月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'Today, the quality of life of people in big cities is getting worse. What are the causes of this problem? Any measures should be taken to solve it?',
    备注: '2019年7月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think learning history in school is important. Some others think learning subjects more relevant to life is important. Discuss both views and give your own opinion.',
    备注: '2019年8月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, the cost of living is on the rise. What effects do higher prices have on individuals and society? How to deal with higher costs?',
    备注: '2019年8月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people say that drug companies have a responsibility to spend money on researching medicines that will help people in poorer countries. Others say the main responsibility of drug companies is to make money.Discuss both these views and give your own opinion.',
    备注: '2019年8月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think zoos are cruel and all the zoos should be closed. However, some people think zoos can help protect the rare animals. Discuss both these views and give your opinion.',
    备注: '2019年8月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more parents are allowing their children to play on computers and tablets as they think that children should learn technology skills.Do the advantages of this development outweigh the disadvantages?',
    备注: '2019年8月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think the manufacturers or shopping malls should sell less packaged products and others argue that people have the responsibility to buy products with less packaging.Discuss both views and give your own opinion.',
    备注: '2019年8月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Research into new types of medicines and treatments is essential for improving health and dealing with diseases. Who do you think should fund these kinds of research: private companies, individuals or governments?',
    备注: '2019年8月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'When new towns are constructed, it is important to build more public parks or sports facilities than shopping centers, so people can have places to spend their free time. To what extent do you agree or disagree?',
    备注: '2019年8月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people claim that public museums and art galleries will not be needed because people can see historical objects and works of art by using a computer. Do you agree or disagree with this opinion?',
    备注: '2019年8月31日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people say that economic growth is the only way to end world poverty and hunger. Others say that economic growth is causing damage to the environment ,and should be stopped now. Discuss both views and give your opinion.',
    备注: '2019年9月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'An increase in production of consumer goods results in damage to the natural environment. What are the causes and possible solutions?',
    备注: '2019年9月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'It is a natural process that animal species such as dinosaurs become extinct. There is no reason for people to prevent this from happening. To what extent do you agree or disagree？',
    备注: '2019年9月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that cultural traditions may be destroyed when they are used as money-making attractions aimed at tourists. Others believe it is the only way to save these traditions. Discuss both views and give your opinion.',
    备注: '2019年9月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Differences in ages between parents and children are greater than in the past. Do you think the advantages of the development outweigh the disadvantages？',
    备注: '2019年9月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Fossil fuels, such as coal, oil and natural gas, are used in many countries. But in some countries, the use of alternative sources of energy, including wind and solar power, has been encouraged. Is this trend a positive or a negative development?',
    备注: '2019年9月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'The best way to reduce youth crime is to educate parents about good parenting skills. To what extent do you agree or disagree?',
    备注: '2019年10月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries, small town-centre shops are going out of business because people tend to drive to large out-of-town stores. As a result, people without cars have limited access to out-of town stores, and it may result in an increase in the use of cars. Do you think the disadvantages of this change outweigh its advantages?',
    备注: '2019年10月10日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more people are using computers and electric devices to access information, so there is no need for printed books, magazines and newspaper. To what extent do you agree or disagree？',
    备注: '2019年10月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think it is necessary to use animals for testing medicines intended for human use. Others, however, think it is cruel to do that. Discuss both of these views and give you own opinion.',
    备注: '2019年10月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'The international community must act immediately to ensure that all the countries reduce the consumption of fossil fuels eg. gas and oil. To what extent do you agree or disagree?',
    备注: '2019年10月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many people today are spending more and more time travelling to work or school. Some people believe this is a negative development while others think there are benefits to spending a long time travelling to work or school. Discuss both views and give your opinion.',
    备注: '2019年10月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that companies and individuals, rather than the government, should pay for cleaning up pollution. To what extent do you agree or disagree with this statement?',
    备注: '2019年10月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'More and more people read news from the Internet, but newspapers will continue to be used by the majority of people. To what extent do you agree or disagree?',
    备注: '2019年10月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'The world of work is changing rapidly. Working conditions today are not the same as before and people no longer rely on taking one job for life. Discuss the possible causes for this change and give your suggestions on how people should prepare for work in the future.',
    备注: '2019年11月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'Which factor is the most important for building a perfect society? What should people do to achieve this goal?',
    备注: '2019年11月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some cultures it is argued that the old age should be valued, while in some cultures youth is more valued. Discuss both views and give your opinion.',
    备注: '2019年11月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'In most countries, prison is the most common solution to the problem of crime. However, some people argue that a more effective way is to provide better education to prevent crime. To what extent do you agree or disagree?',
    备注: '2019年11月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people claim that public museums and art galleries will not be needed because people can see historical objects and works of art by using a computer. Do you agree or disagree with this opinion?',
    备注: '2019年11月16日全真题',
  },
  {
    类型: '雅思',
    题目: "A family has a great influence on children's development, but the outside of home plays a bigger part in children's life. Do you agree or disagree?",
    备注: '2019年11月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'In modern society, it is no longer necessary to slaughter animals for producing foodstuffs, or non-food products such as clothes or medicine. To what extent do you agree or disagree?',
    备注: '2019年11月30日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people suggest that a country should try to produce all the food for its population and import as little food as possible. To what extent do you agree or disagree?',
    备注: '2019年11月30日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays there is a growing amount of advertising aimed at children. Some people think this has negative effects on children and should be banned. To what extent do you agree or disagree?',
    备注: '2019年12月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays, some older people choose to live in the retirement communities with other people, rather than living with their adult children. Is it a positive or negative development?',
    备注: '2019年12月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many young people change their jobs or careers every few years. What are the reasons for this? Do the advantages of this outweigh the disadvantages?',
    备注: '2019年12月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'A few languages are increasingly spoken in different countries, while the usage of others is rapidly declining. Is this a positive or a negative development ?',
    备注: '2019年12月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some think that children should start school as early as possible, while others believe that they should start schools at the age of seven. Discuss both views and give your own opinion.',
    备注: '2019年12月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries today people are living in a ‘throw-away society’, where things are used in a short time and then thrown away. What are its causes? What are its problems?',
    备注: '2019年12月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Today，many people spend less and less time in their homes. What’s the reason for it? What are the effects of this trend on individuals and society?',
    备注: '2019年12月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think children’s spending time on TV, video and PC games is good, while others think it is bad. Discuss both views and give your own opinion.',
    备注: '2021年1月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that criminals should be given longer terms in prison, so as to reducethe crime rate. To what e_tent do you agree or disagree?',
    备注: '2021年1月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Old generations often hold some traditional ideas on the correct way of life, thinking and behavior. However, some people think that it is not helpful for the young generations to prepare for modern life in the future. What’s your opinion?',
    备注: '2021年1月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'In countries (where there is high unemployment) most pupils should be offered only primary education; there is no point in offering secondary education to those who will have no hope of finding a job. To what e_tent do you agree or disagree?',
    备注: '2021年1月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think people can e_ploit animals for any purpose they need, while others do not think so. What is your opinion?',
    备注: '2021年2月2日全真题',
  },
  {
    类型: '雅思',
    题目: 'An increasing number of people choose to live in big cities. What problems will this bring about? Should the government encourage people to live in small towns?',
    备注: '2021年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'An American film actor once said,” Tomorrow is important and precious.” Some people think individuals and society should pay more attention to the future than to the present. Do you agree or disagree?',
    备注: '2021年2月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think imported food e_erts positive impacts on our lives. To what e_tent do you agree or disagree?',
    备注: '2021年2月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'Schools offer a wide range of courses such as physical education, music, economics, philosophy, math, English，geography, physics and history. Among all these subjects, which one do you think is the most important and which one is the least important?',
    备注: '2021年3月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'The number of cars keeps increasing, so road systems should be e_panded. Some people think the government should pay for it, while others think the car owners should pay for it. What’s your opinion?',
    备注: '2021年3月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'People should look after their health as a duty to the society they live in rather than personal benefits. To what e_tent do you agree or disagree?',
    备注: '2021年3月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think government should ensure the healthy lifestyle. of people, but others argue that it should be decided by individuals. Discuss both views and give your opinion.',
    备注: '2021年3月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'The leaders or directors of organizations are often older people. But some people say。 that young people can also be a leader. To what extent do you agree or disagree?',
    备注: '2022年1月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people argue that too much attention and too many resources are given to the rotection of wild animals and birds. To what extent do you agree or disagree?',
    备注: '2022年1月31日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that the age limit for driving should be increased in order to make driving safer. To what extent do you agree or disagree?',
    备注: '2022年2月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'The use of mobile phone is as antisocial as smoking. Smoking is banned in certain places so mobile should be banned like smoking. To what extend do agree or disagree?',
    备注: '2022年2月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that it is more important to plant more trees in open area in towns and cities than build more housing. To what extend do agree or disagree?',
    备注: '2022年3月12日全真题',
  },
  {
    类型: '雅思',
    题目: "Some people think that using mobile phones and computers has a negative effect on young people's reading and writing skills. To what extent do you agree or disagree?",
    备注: '2022年3月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe that young people who commit serious crimes should be punished in the same way as adults. To what extent do you agree or disagree?',
    备注: '2022年4月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that advertising discourages us from being different individuals, as all people want to do the same and look the same. To what extent do you agree or disagree?',
    备注: '2022年7月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'As well as making money, businesses should have other social responsibilities. To what extent do you agree or disagree?',
    备注: '2022年7月25日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people who have been in prison become good citizens later, some people think that they are the best people to talk to school students the danger of committing a crime,do you agree or disagree?',
    备注: '2022年8月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Students in school or university can learn more from classes and teachers than from other sources (e.g. the Internet or TV）. To what extent do you agree or disagree?',
    备注: '2022年9月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think everyone should be a vegetarian and they do not need to eat meat to stay healthy. To what extent do you agree or disagree？',
    备注: '2022年9月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think governments should focus on reducing environmental pollution and housing problems to help people prevent illness and disease. To what extent do you agree or disagree?',
    备注: '2022年10月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'For schoolchildren, their teachers have more influence on their intelligence and social development than their parents. To what extent do you agree or disagree?',
    备注: '2022年11月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'The best way to teach children to cooperate with others is through team sports at school. To what extent do you agree or disagree?',
    备注: '2022年11月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'The government should spend money in promoting sport and art in school, rather than sponsoring professional sports and art events in communities. To what extent do you agree or disagree?',
    备注: '2022年11月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays, most people concentrate on academic subjects in university, but some experts suggest that we should encourage students to learn vocational skills. To what extent do you agree or disagree?',
    备注: '2022年11月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Interviews form the basic selecting procedure for most large companies. However some people think interviews is not a reliable means of choosing who to employ and there are some other better methods of selection. To what extent do you agree or disagree?',
    备注: '2022年12月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'Reading story books is better for children than watching television or playing computer games. To what extent do you agree or disagree?',
    备注: '2022年12月12日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that the amount of noise people make should be controlled strictly, while other say that people are free to make as much noise as they wish. Discuss both views and give your opinion.',
    备注: '2022年1月17日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some working parents believe childcare centers can provide best care for children, while others think family members like grandparents can do it better. Discuss oth views and give your opinion.',
    备注: '2022年3月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe famous people’s support towards international aid organizations draws the attention to problems, while others think celebrities make the roblems less important. Discuss both views and give your opinions.',
    备注: '2022年3月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that only the best students should be rewarded. Others, however, think that it is more important to reward students who show improvements. iscuss both these views and give your own opinion.',
    备注: '2022年4月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Developments in science and technology have caused environmental problems. Some people think that a simpler way of life will protect the environment, while others believe that science and technology can solve environmental problems. Discuss both views and give your own opinion.',
    备注: '2022年5月9日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe that in order to improve educational quality, we should encourage students to make comments or even criticism on their teachers, but others think it will lead to the loss of respect and discipline in the classroom. Discuss both views and give your own opinion.',
    备注: '2022年5月16日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people prefer to provide help or support directly to the local community, while others think we should donate aid to national or international charitable rganizations. Discuss both views and give your own opinion.',
    备注: '2022年6月6日全真题',
  },
  {
    类型: '雅思',
    题目: "Some people say the government should give priority to the health care, while others believe that tax payers' money should be spent on more important things. Discuss both views and give your own opinion.",
    备注: '2022年7月23日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people who have been in prison become good citizens later, some people think that they are the best people to talk to school students the danger of committing a crime,do you agree or disagree?',
    备注: '2022年8月8日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think the increasing business and cultural contact between countries is a positive development, while others believe this will lead to the loss of national identities. Discuss both views and give your own opinion.',
    备注: '2022年8月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people believe more actions can be taken to prevent crimes, while others think that little can be done. Discuss both views and give your own opinion.',
    备注: '2022年9月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people say that playing computer games is bad for children in every way. Others say that playing computer games can have positive effects on the way children develop. Discuss both views and give your opinion.',
    备注: '2022年10月24日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that creative artists should be financially supported by the government;others think that these artists should look for other sources of support. Discuss both views and give your own opinion.',
    备注: '2022年10月31日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some people think that cultural traditions will be destroyed as they are used as money-aking attractions, while others think it is the only way so save them. Discuss both views and give your opinion.',
    备注: '2022年12月19日全真题',
  },
  {
    类型: '雅思',
    题目: 'It is possible for scientists and tourists to travel to remote natural environments, such as South Pole. Do you think the advantages of this development outweigh the disadvantages?',
    备注: '2022年1月29日全真题',
  },
  {
    类型: '雅思',
    题目: 'Some students take one year off between finishing school and going to university, in order to travel or to work. Do you think advantages outweigh disadvantages?',
    备注: '2022年2月28日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries, more and more adults choose to continue to live with their parents after they graduate and have found jobs. Do the advantages of this trend outweigh its disadvantages?',
    备注: '2022年4月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'Because of traffic and housing problems in the cities，the government encourages business to move to the rural area. Do you think the advantages outweigh the disadvantages?',
    备注: '2022年6月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'It is suggested that young adults should undertake a period of unpaid work in the community. Does it bring more benefits or drawbacks to the community and young people?',
    备注: '2022年7月4日全真题',
  },
  {
    类型: '雅思',
    题目: 'School leavers go travelling or work before they go directly to university. Are there more advantages or disadvantage on their study?',
    备注: '2022年11月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'People are surrounded by many kinds of advertising which can influence their life. Does the positive effect of this trend outweigh negative effect?',
    备注: '2022年12月5日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many museums and historical sites are mainly visited by tourists, not local people. Why? What can be done to attract local people?',
    备注: '2022年2月7日全真题',
  },
  {
    类型: '雅思',
    题目: 'Older people who need employment have to compete with younger people. What problems will be caused? And what are the solutions?',
    备注: '2022年4月11日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries around the world men and women are having children late in life. What are the reasons for this development? What are the effects on society and family life?',
    备注: '2022年5月21日全真题',
  },
  {
    类型: '雅思',
    题目: 'Many countries believe that international tourism has harmful effects. Why do they think so? What can be done to change their views?',
    备注: '2022年5月3日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, a high proportion of criminal acts are committed by teenagers. What are the reasons and what do you suggest to solve this problem？',
    备注: '2022年6月18日全真题',
  },
  {
    类型: '雅思',
    题目: 'Nowadays, many people do not feel safe either when they are at home or go out. What are the reasons and what can be done to solve this problem?',
    备注: '2022年6月27日全真题',
  },
  {
    类型: '雅思',
    题目: 'The natural resources such as oil, forests and water are being consumed at an alarming rate. What problems does it cause and how can we solve these problems?',
    备注: '2022年8月1日全真题',
  },
  {
    类型: '雅思',
    题目: 'International travel make people prejudiced more than board-mind, why? How to improve the understanding of countries they visit?',
    备注: '2022年8月13日全真题',
  },
  {
    类型: '雅思',
    题目: 'In many countries, there is not enough recycling of waste materials (e.g. paper, glass, cans).What are the reasons and solutions?',
    备注: '2022年9月26日全真题',
  },
  {
    类型: '雅思',
    题目: 'Consumption of the world’s resources(such as oil, fresh water,etc.) is increasing at a dangerous rate. What are the causes of this increased consumption? What can people do reduce it?',
    备注: '2022年11月14日全真题',
  },
  {
    类型: '雅思',
    题目: 'In some countries, the role of a mother differs in some ways from the role of a father. Why do you think the differences exist? How might parental roles develop in the future?',
    备注: '2022年11月21日全真题',
  },
]
export default ques
